<template>
  <path
    d="M14.4 6.00018L14.16 4.80018C14.07 4.34018 13.66 4.00018 13.18 4.00018H6C5.45 4.00018 5 4.45018 5 5.00018V20.0002C5 20.5502 5.45 21.0002 6 21.0002C6.55 21.0002 7 20.5502 7 20.0002V14.0002H12.6L12.84 15.2002C12.93 15.6702 13.34 16.0002 13.82 16.0002H19C19.55 16.0002 20 15.5502 20 15.0002V7.00018C20 6.45018 19.55 6.00018 19 6.00018H14.4Z"
  />
</template>
